import isBefore from 'date-fns/isBefore';
import isAfter from 'date-fns/isAfter';
var dateInRange = function dateInRange(_a) {
  var getDateFrom = _a.getDateFrom,
    getDateTo = _a.getDateTo,
    _b = _a.messageBeforeFrom,
    messageBeforeFrom = _b === void 0 ? 'Неверная дата' : _b,
    _c = _a.messageAfterTo,
    messageAfterTo = _c === void 0 ? 'Неверная дата' : _c;
  return function (date) {
    if (getDateFrom && isBefore(date, getDateFrom())) {
      return messageBeforeFrom;
    }
    if (getDateTo && isAfter(date, getDateTo())) {
      return messageAfterTo;
    }
    return;
  };
};
export default dateInRange;
export { dateInRange };